import React from 'react'
import { API, ids_hospitales, getData, sendDataBody } from '../../resources'
import { usuario } from '../../resources'
import { useState, useEffect, useRef } from 'react'
import Loading from '../../loading'
import { Col, Row, Select, Button } from 'antd'
import Expedientes from '../../doctorViews/expedientes/expedientes'
import { useLocation } from 'react-router-dom'
import { RegisterModalNext } from './register'
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
const { Option } = Select;

// SHARED WITH RECEPTION / ENFERM. TODO: REFACTOR TO AVOID DUPLICATED CODE WITH ADMIN VIEWS

export default function PacientesNext() {

    // For the case that comes from another view
    const { state } = useLocation();
    const name_from_state = state?.name ?? null

    // Modal Register Patient
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isModalEditOpen, setIsModalEditOpen] = useState(false)


    const [pacientes, setPacientes] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [paciente, setPaciente] = useState(null)
    const idmedsRef = useRef([])
    const initialPacientesRef = useRef([])

    useEffect(() => {
        getPacientes()
    }, [])

    const getPacientes = async () => {
        const meds = await getData(`users/hospital/${ids_hospitales[0]}`)
        const idmeds = meds.map(doc => doc._id)
        idmedsRef.current = idmeds

        const endpoint = name_from_state ? 'pacientes/medicos/search/name' : 'pacientes/medicos/first'
        const body = name_from_state ? { medicos: idmeds, search: name_from_state } : { medicos: idmeds }
        sendDataBody(endpoint, body).then((rs) => {
            initialPacientesRef.current = rs
            setPacientes(rs)
            if (!paciente) setPaciente(rs[0])
            setIsLoading(false)
        })
    }


    // Search patient
    const onChange = (data) => {
        const found = pacientes.find(p => p._id === data)
        setPaciente(found)
        console.log('active patient', found)
    };

    const onChangePhone = (data) => {
        const found = pacientes.find(p => p.telefono === data)
        setPaciente(found)
        console.log('active patient', found)
    };

    const onSearch = (value) => {
        if (!value) {
            setPacientes(initialPacientesRef.current)
            return
        }
        sendDataBody('pacientes/medicos/search/name', {
            medicos: idmedsRef.current,
            search: value,
        }).then((rs) => {
            setPacientes(rs)
        })
    };

    // end search patient


    if (isLoading) return <Loading />

    return (
        <div className='mainContainer' style={{ backgroundColor: '#F0F4F8' }}>

            {/* {
                JSON.stringify(pacientes)
            } */}
            <h1>Pacientes</h1>

            <Row justify="start">
                <Col>
                    <div className="my-select-container">
                        <Select
                            // Widget para buscar pacientes
                            style={{ borderRadius: 8, width: 380 }}
                            dropdownStyle={{ borderRadius: 8 }}
                            showSearch
                            placeholder="Buscar paciente"
                            onChange={onChange}
                            onSearch={onSearch}
                            filterOption={false}
                        >
                            {
                                pacientes.map((p) => <Option key={p._id} value={p._id}>{p.name}</Option>)
                            }
                        </Select>
                    </div>
                </Col>

                <Col>
                    <div className="my-select-container">
                        <Select
                            // Widget para buscar pacientes
                            style={{ borderRadius: 8, width: 360, marginLeft: 12 }}
                            dropdownStyle={{ borderRadius: 8 }}
                            showSearch
                            placeholder="Buscar por telefono"
                            optionFilterProp="children"
                            onChange={onChangePhone}
                            onSearch={onSearch}
                        >
                            {
                                pacientes.map((p) => <Option key={p._id} value={p.telefono}>{p.telefono} {p.name}</Option>)
                            }
                        </Select>
                    </div>
                </Col>
                <Col style={{ marginLeft: 12 }}>
                    <Button className='btnIconCentered' style={{ height: 30, marginRight: 12 }} onClick={() => setIsModalEditOpen(!isModalEditOpen)} size='small' icon={<EditOutlined />} shape='round' type="primary" ghost title='Editar paciente' >Editar Paciente</Button>
                    <Button className='btnIconCentered' style={{ height: 30 }} onClick={() => setIsModalOpen(!isModalOpen)} size='small' icon={<PlusOutlined />} shape='round' type="primary" title='Registrar paciente' >Registrar Paciente</Button>
                </Col>




            </Row>
            {
                paciente ? (
                    <Expedientes paciente={paciente} setIsEditModalOpen={() => { console.log('setIsEditModalOpen') }} />

                ) : <div>No hay paciente seleccionado</div>
            }

            {/* For Register Modal */}
            <RegisterModalNext isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} getPacientesData={getPacientes} />
            {/* For Edit Modal */}
            <RegisterModalNext isModalOpen={isModalEditOpen} setIsModalOpen={setIsModalEditOpen} paciente={paciente} getPacientesData={getPacientes} />
        </div>
    )
}